// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__25dm2","content":"GlobalSearch_content__1s7p_"};